import { useParams } from 'react-router-dom';
import { PageType } from '@vgtv/api-client/lib/page';

import { PageComponents } from '../components/PageComponents/PageComponents';
import { PageMetadata } from '../components/PageMetadata/PageMetadata';
import { PageSpinner } from '../components/PageSpinner/PageSpinner';
import { usePageViewTracking } from '../components/utils/usePageViewTracking';
import { getHomepageSlug } from '../shared/helpers/getHomepageSlug';
import { config } from '../config';

import { usePageConfig } from './usePageConfig';
import { NotFoundPage } from './NotFoundPage';

import type { FC } from 'react';

const CustomPage: FC = () => {
  const { slug } = useParams<{ slug?: string }>();

  const { pageConfig, isFetching, isFetched } = usePageConfig({
    identifier: slug ? slug : getHomepageSlug(config.provider),
    pageType: PageType.CUSTOM,
    vendor: config.provider,
  });

  usePageViewTracking({
    pageType: PageType.CUSTOM,
    entity: pageConfig ? { slug: pageConfig.slug } : undefined,
  });

  if (!pageConfig) {
    if (isFetching) {
      return <PageSpinner />;
    }

    if (!isFetching && isFetched) {
      return <NotFoundPage />;
    }

    return null;
  }

  return (
    <>
      <PageMetadata
        entity={{ slug: pageConfig.slug }}
        pageType={PageType.CUSTOM}
        overrides={pageConfig.meta}
      />
      <PageComponents componentsConfig={pageConfig.components} />
    </>
  );
};

export { CustomPage };
